<template>
    <vx-unit-input
        v-model="localValue"
        v-bind="$attrs"
        v-on="$listeners"
        select-on-focus
        disable-chrome-autocomplete
        type="number"
        :label="label"
        :label-placeholder="labelPlaceholder"
        placeholder="0.00"
        icon="icon-dollar-sign"
        :disabled="disabled"
        :unit-options="currencyOptions"
        :unit.sync="localCurrency"
        @inputBlurred="parseInput"
    >
    </vx-unit-input>
</template>

<script>
export default {
    name: 'vx-currency-input',
    props: {
        value: {
            type: [Number, String]
        },
        label: {
            type: String
        },
        disabled: {
            type: Boolean,
            default: false
        },
        labelPlaceholder: {
            type: String
        },
        currencyOptions: {
            type: [Array, String],
            default: 'AUD'
        },
        currency: {
            type: String
        }
    },
    data() {
        return {
            appendFocused: false,
            inputFocused: false
        }
    },
    computed: {
        hasLabel() {
            return this.label || this.labelPlaceholder
        },
        localValue: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        },
        localCurrency: {
            get() {
                return this.currency
            },
            set(val) {
                this.$emit('update:currency', val)
            }
        }
    },
    methods: {
        parseInput() {
            if (this.localValue) {
                if (typeof this.localValue === 'string') {
                    this.$emit('input', parseFloat(this.localValue.replace(',', '')).toFixed(2))
                } else {
                    this.$emit('input', this.localValue.toFixed(2))
                }
            }
        }
    }
}
</script>
